module.exports = __webpack_public_path__ + "img/hzhb1.eecc95bb.png";